import AnalyticsService from './src/services/analytics.service';
import wrapWithProvider from './wrap-with-provider';

export const wrapRootElement = wrapWithProvider;

export const onRouteUpdate = () => {
  setTimeout(() => {
    // Segment will automatically read the canonical url first (used for SEO and is set to the prod url).
    // So we need to explicitly set the `url` value to the actual page url
    AnalyticsService.page(document.title, { url: location.href });
  }, 50); // Add a short delay so that page calls are accurrate for current rather than previous page
};
